import React, { useEffect } from 'react'
import App from './app'
import { Alert } from '@mui/material'
import { useFetch } from './hooks/fetch.hook'
import { ApiConfigResponse } from './domain/config'
import { fetchConfig } from './services/app.config'
import { useConfiguration } from './components/AppConfigProvider/AppConfigProvider'
import { MainPageBox } from './components/DisplayHelpers/MainPageBox'
import { PacelineLoaderIcon } from './components/Icons/PacelineLoaderIcon'

export const AppConfigLoader: React.FC = () => {
  const { setConfig, configurationLoaded } = useConfiguration()
  const { data, error, loading } = useFetch<ApiConfigResponse>(fetchConfig)

  useEffect(() => {
    if (!!data && !loading) setConfig(data)
  }, [data])

  if (error) {
    return (
      <MainPageBox>
        <Alert severity="error">
          Error Loading Configuration, contact support or reload browser
        </Alert>
      </MainPageBox>
    )
  }

  if (configurationLoaded()) {
    return <App />
  }

  return (
    <MainPageBox>
      <div style={{ marginTop: 200 }}>
        <PacelineLoaderIcon />
      </div>
    </MainPageBox>
  )
}

export default AppConfigLoader
